import React, {PureComponent} from "react";
import {Container, Col, Row} from "reactstrap";
import PubSub from 'pubsub-js';
import Widget from '../../../components/Widget';
import {SectionalCountry} from "../../../components/CountrySectional/SectionalCountry";
import {CountrySectionalComparativeModel} from "../../../components/CountrySectional/model/CountrySectionalComparativeModel";
import {SeccionalBanco} from "../objects/SeccionalBanco";
import SectionalComparative from "../charts/PieChart";
import 'react-toastify/dist/ReactToastify.css';
import s from '../seccionales.module.scss';

export class DetalleSeccional extends PureComponent {
    state = {
        data : [],
        dataGlobal : [],
        compliance: [],
        totalCompliance: [],
        maxYear : this.props.maxYear,
        mes : this.props.mes,
        sectional : this.props.sectional
    }

    componentDidMount() {
        PubSub.subscribe('reloadmaxYear', this.onmaxyaer.bind(this));
        PubSub.subscribe('reloadmes', this.onmes.bind(this));
        PubSub.subscribe('reloadsectional', this.onsectional.bind(this));
        this.props.onLoading(true);
        this.getInfoSales(this.state.maxYear, this.props.mes, this.props.sectional);
    }

    onmaxyaer() {
        console.log(this.props.maxYear);
        this.props.onLoading(true);
        this.setState({
            maxYear: this.props.maxYear
        })
        this.props.onLoading(false);
    }
    onmes() {
        console.log(this.props.mes);
        this.props.onLoading(true);
        this.setState({
            mes: this.props.mes
        })
        this.props.onLoading(false);
    }
    onsectional() {
        console.log(this.props.sectional);
        this.props.onLoading(true);
        this.setState({
            sectional: this.props.sectional
        })
        this.props.onLoading(false);
    }

    componentDidUpdate() {
        this.props.onLoading(true);
        if (this.state.maxYear  != this.props.maxYear || this.state.mes != this.props.mes || this.state.sectional != this.props.sectional) {
            this.getInfoSales(this.state.maxYear, this.props.mes, this.props.sectional);
        }
    }


    getInfoSales(anio,mes,sectional) {

        if(anio!= null){
            // this.API_URL =  "/salesleaders/anio/"+anio+"/seccional/"+sectional+"/mes/"+mes
            //this.API_COMPLIANCE = "/SalesBySeccional/anio/"+anio+"/seccional/"+sectional+"/mes/"+mes
            this.API_URL =  "/SectionalBankCount/anio/"+anio+"/seccional/"+sectional+"/mes/"+mes
            this.API_URL_SECTIONAL_COUNTRY =  "/CountrySectionalCount/anio/"+anio+"/seccional/"+sectional+"/mes/"+mes
            //this.API_URL_SECTIONAL =  "/SectionalCount/anio/"+anio+"/seccional/"+sectional+"/mes/"+mes
        }

        fetch(this.API_URL)
            .then((res) => res.json())
            .then((data1) => {
                console.log(data1)
                var structure = []
                data1.map(item => {
                    let seccional  = new SeccionalBanco(item.banco, item.total)
                    structure.push(seccional)
                });

                this.setState(() => ({
                    data: structure
                }), ()=>{

                })
            });

        fetch(this.API_URL_SECTIONAL_COUNTRY)
            .then((res) => res.json())
            .then((data1) => {
                var structure1 = [];
                var i = 0;
                let seccionalValue = 0;
                data1.map(item => {

                    if(i === 0){
                        seccionalValue = item.total;
                        let seccional = new CountrySectionalComparativeModel("Seccional", seccionalValue);
                        structure1.push(seccional);
                    }
                    if(i === 1){
                        let pais = new CountrySectionalComparativeModel("Resto del Pais", item.total - seccionalValue);
                        structure1.push(pais);
                    }
                    i++;
                });
                this.setState(() => ({
                    dataGlobal : structure1
                }), ()=>{
                    this.props.onLoading(false);
                })
            });

    }
    render() {
        return(
            <Container fluid>
            <Row>
                <Col sm = {6} >
                    <Widget
                        title={<h5><span className="fw-semi-bold">Seccional por Banco</span></h5>}>
                        {this.state.maxYear ?
                            <SectionalComparative data ={this.state.data}
                            /> : null}
                    </Widget>
                </Col>
                <Col  sm = {6}>
                    <Widget
                        title={<h5><span className="fw-semi-bold">Seccional vs País</span></h5>}>
                        {this.state.maxYear ?
                            <SectionalCountry data = {this.state.dataGlobal}
                            /> : null}
                    </Widget>
                </Col>
            </Row>
            </Container>
        )
    }
}